define.alias("checkout/components/seamless-checkout/checkout-success-modal", "settings/components/seamless-checkout/checkout-success-modal");